import Elegant   from './Elegant/Elegant';
import Kabbalah  from './Kabbalah/Kabbalah';
import Grid      from './Grid/Grid';
import Parchment from './Parchment/Parchment';
import Modern    from './Modern/Modern';
import WeekView  from './WeekView/WeekView';

const templates = {
  Elegant,
  Kabbalah,
  Grid,
  Parchment,
  Modern,
  WeekView,
};

export default templates;
